export const LOGGER_NAME = 'ecom-website';
